module.exports = __webpack_public_path__ + "img/uofa-engg.48b13028.png";